import { render, staticRenderFns } from "./HasGarden.vue?vue&type=template&id=3ddb2272&"
import script from "./HasGarden.vue?vue&type=script&lang=ts&"
export * from "./HasGarden.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports